import { render } from "./opTableServerSide.vue?vue&type=template&id=f84fd876&ts=true"
import script from "./opTableServerSide.vue?vue&type=script&lang=ts"
export * from "./opTableServerSide.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__